import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Render Expand All / Collapse All buttons above the card stack.
   *
   * @type {Boolean|String}
   * @default false
   */
  showGlobalControls: booleanAttribute(),
});
